/**
 * IssuesList - Display issues as a list
 */

import type { Issue } from '../types';
import './IssuesList.css';

interface IssuesListProps {
  issues: Issue[];
}

export function IssuesList({ issues }: IssuesListProps) {
  return (
    <div className="issues-list">
      {issues.map((issue) => {
        const hasNoEstimate = issue.fields.storyPoints === undefined || issue.fields.storyPoints === null;
        return (
          <div
            key={issue.id}
            className={`issue-item ${hasNoEstimate ? 'no-estimate' : ''}`}
          >
            <span className="issue-key">{issue.key}</span>
            <span className="issue-summary">{issue.fields.summary}</span>
            <span className={`issue-status status-${issue.fields.status.statusCategory.key}`}>
              {issue.fields.status.name}
            </span>
            <span className="issue-points">
              {hasNoEstimate ? (
                <span className="no-points-warning">NO SP</span>
              ) : (
                `${issue.fields.storyPoints} SP`
              )}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default IssuesList;
